import React from 'react';
import Button from "react-bootstrap/lib/Button";
import {API_URL} from "../constants";

function WhovaTab() {
    return (
        <div>
            <p>Here you can download the whova of the conference in a spreadsheet format:</p>

            <a href={API_URL + '/admin/whova'}>
                <Button bsStyle="success">Get whova</Button>
            </a>
        </div>
    )
}

export default WhovaTab
